exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n    border-radius: 4px;\n    background-size: cover;\n    width: 98.3%;\n    padding: 10;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    text-align: center;\n    margin-left: 0;\n}\n\n.container.info {\n    background-color: #f4f1f9;\n    border: 1px solid #9476c9;\n    color: #9476c9;\n    text-decoration: none solid rgb(148, 118, 201);\n}\n\n.container.warn {\n    background-color: #fff6ed;\n    border: 1px solid #f79b42;\n    color: #f79b42;\n    text-decoration: none solid rgb(247, 155, 66);\n}\n\n.container.err {\n    border: 1px solid #f1736a;\n    background-color: #fdf2f1;\n    color: #f1736a;\n    text-decoration: none solid rgb(241, 115, 106);\n}\n\n.container.success {\n    border: 1px solid #38b6a0;\n    background-color: #ecf8f6;\n    color: #38b6a0;\n    text-decoration: none solid rgb(56, 182, 160);\n}\n\n.btn {\n    border: 1px solid #acadc1;\n    background-color: #ffffff;\n    background-size: cover;\n    font-family: Open Sans;\n    font-size: 16px;\n    color: #26273b;\n    text-decoration: none solid rgb(38, 39, 59);\n}\n\np {\n    margin: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/common/communication-box/communication-box.component.css
// module id = 814
// module chunks = 0